// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  encounterId: __t.u64().primaryKey().name("encounter_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  aId: __t.u64().name("a_id"),
  bId: __t.u64().name("b_id"),
  playerHex: __t.string().name("player_hex"),
  kind: __t.string(),
  state: __t.string(),
  targetDist: __t.f32().name("target_dist"),
  tier: __t.string(),
  escalation: __t.u32(),
  startedAt: __t.timestamp().name("started_at"),
  stateSince: __t.timestamp().name("state_since"),
  expiresAt: __t.timestamp().name("expires_at"),
});
